var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center"},[_c('VProgressCircular',{staticClass:"progress--wrap",attrs:{"rotate":360,"size":200,"width":25,"value":_vm.value,"color":"blue"}},[_vm._v(" "+_vm._s(_vm.value)+" %")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }